import { render } from "./BottomNavigationItem.vue?vue&type=template&id=19ff7982&scoped=true"
import script from "./BottomNavigationItem.vue?vue&type=script&lang=js"
export * from "./BottomNavigationItem.vue?vue&type=script&lang=js"

import "./BottomNavigationItem.vue?vue&type=style&index=0&id=19ff7982&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ff7982"]])

export default __exports__